(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('form');
    const qty = form.elements.quantity;
    const plan = form.elements.selling_plan;
    const recurringRadio = root.querySelector('[data-recurring-radio]');
    const frequency = root.querySelector('[data-frequency]');
    const onceRadio = root.querySelector('input[value="once"]');
    const tiers = [...root.querySelectorAll('[data-tier-min]')];
    const copy = JSON.parse(root.querySelector('[data-ff-copy]').textContent);
    const base = Number(root.dataset.baseCents);
    const currency = root.dataset.currency;
    const money = (cents, showCode = false) => new Intl.NumberFormat('en-CA', {style:'currency',currency,currencyDisplay:'code'}).format(cents / 100).replace(/^CAD\s*/, '$') + (currency === 'CAD' && showCode ? ' CAD' : '');
    const validQuantity = () => Number.isSafeInteger(Number(qty.value)) && Number(qty.value) >= 1;
    const normalize = () => { if (!validQuantity()) qty.value = '1'; };
    function update() {
      const quantity = validQuantity() ? Number(qty.value) : 1;
      const tier = tiers.filter(t => quantity >= Number(t.dataset.tierMin)).at(-1);
      const recurring = recurringRadio.checked && frequency.options.length > 0;
      const excludedSubscription = recurring && ['inks', 'thermal'].includes(root.dataset.bulk);
      const unit = Math.ceil(base * (100 - (excludedSubscription ? 0 : Number(tier?.dataset.discount || 0))) / 100);
      root.querySelectorAll('.ff-purchase__bulk-heading, .ff-purchase__tiers').forEach(el => { el.hidden = excludedSubscription; });
      plan.disabled = !recurring;
      plan.value = recurring ? frequency.value : '';
      frequency.disabled = !recurring;
      root.querySelector('.ff-purchase__frequency').hidden = !recurring;
      root.querySelector('[data-unit-price]').textContent = money(unit, true);
      root.querySelector('[data-total]').textContent = money(unit * quantity);
      root.querySelector('[data-summary-label]').textContent = recurring && !excludedSubscription ? copy.recurringSubtotal.replace('{{ frequency }}', frequency.selectedOptions[0].textContent.toLowerCase()).replace('__FREQUENCY__', frequency.selectedOptions[0].textContent.toLowerCase()) : copy.subtotal;
      root.querySelector('[data-mode-note]').textContent = recurring ? copy.recurringNote : copy.onceNote;
      root.querySelector('[data-mode-note]').hidden = recurring && !copy.recurringNote;
      root.querySelector('[data-step="-1"]').disabled = quantity <= 1;
      tiers.forEach(t => t.setAttribute('aria-pressed', String(t === tier)));
    }
    root.querySelector('[data-variant-url]')?.addEventListener('change', event => { window.location.assign(event.target.value); });
    qty.value = '1';
    onceRadio.checked = true;
    recurringRadio.disabled = frequency.options.length === 0;
    root.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => { normalize(); qty.value = String(Math.max(1, Number(qty.value) + Number(button.dataset.step))); update(); }));
    tiers.forEach(button => button.addEventListener('click', () => { qty.value = button.dataset.tierMin; update(); }));
    qty.addEventListener('input', update);
    qty.addEventListener('change', () => { normalize(); update(); });
    root.querySelectorAll('input[name="purchase_option"]').forEach(input => input.addEventListener('change', update));
    frequency.addEventListener('change', update);
    form.addEventListener('submit', () => { normalize(); update(); });
    root.closest('.productView-product')?.querySelectorAll('.ff-buying-facts dl > div').forEach(row => { if (root.dataset.bulk === 'none' && row.querySelector('dt')?.textContent.trim() === 'Volume discounts') row.hidden = true; const dd = row.querySelector('dd'); if (dd) dd.textContent = dd.textContent.replace(/ CAD/g, ''); });
    update();
  }
  function scan(scope = document) { scope.querySelectorAll('[data-ff-purchase]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan()); else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();